define('display/layers/optionsComplementor',[], function() {
    return {
        fillInTiles512Options: function(options, tileSizeEstimator) {
            options.tileSize = tileSizeEstimator(options);
            if (options.tileSize === 512) {
                options.zoomOffset -= 1;
                options.minZoom = options.minZoom > 0 ? options.minZoom - 1 : 0;
            }
        },
        fillInSubdomainsOptions: function(options) {
            if (typeof options.subdomains === 'string') {
                options.subdomains = options.subdomains.split('');
            }
        }
    }
});

